'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.input = exports.INPUT_CLEAR = exports.INPUT_SET = undefined;

var _atpPointfree = require('atp-pointfree');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//Action type definitions
var INPUT_SET = exports.INPUT_SET = 'basic/input/set';
var INPUT_CLEAR = exports.INPUT_CLEAR = 'basic/input/clear';

//Action creators and selectors
var input = exports.input = {
    set: function set(name, value) {
        return { type: value ? INPUT_SET : INPUT_CLEAR, name: name, value: value };
    },
    clear: function clear(name) {
        return { type: INPUT_CLEAR, name: name };
    },
    value: function value(getState, name) {
        return getState().basic.input[name] || null;
    }
};

//Reducer

exports.default = function () {
    var _switchOn;

    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];
    return (0, _atpPointfree.switchOn)(action.type, (_switchOn = {}, _defineProperty(_switchOn, INPUT_SET, function () {
        return (0, _atpPointfree.merge)(state, _defineProperty({}, action.name, action.value));
    }), _defineProperty(_switchOn, INPUT_CLEAR, function () {
        return (0, _atpPointfree.remove)(action.name)(state);
    }), _defineProperty(_switchOn, 'default', function _default() {
        return state;
    }), _switchOn));
};